import { TableFilter } from 'components/UI/Table';
import { GroupsEnum } from 'types/users';

export const createSortHandler = (filter: TableFilter, setFilter: (filter: TableFilter) => void) => {
	return (key: string) => {
		const isSameKey = filter.sortKey === key;

		if (isSameKey) {
			if (!filter.sortDirection) {
				setFilter({ ...filter, sortKey: key, sortDirection: 'asc' });
			} else if (filter.sortDirection === 'asc') {
				setFilter({ ...filter, sortKey: key, sortDirection: 'desc' });
			} else {
				setFilter({ ...filter, sortKey: undefined, sortDirection: undefined });
			}
		} else {
			setFilter({ ...filter, sortKey: key, sortDirection: 'asc' });
		}
	};
};

export const buildQueryParams = (filter: TableFilter): string => {
	return Object.entries(filter)
		.filter(([key, value]) => {
			// Пропускаем undefined, null и пустые строки
			return value !== undefined && value !== null && value !== '';
		})
		.map(([key, value]) => {
			// Кодируем значения для безопасной передачи в URL
			return `${key}=${encodeURIComponent(value)}`;
		})
		.join('&');
};

/**
 * Применяет фильтр storeId в зависимости от прав доступа пользователя
 * Администраторы и пользователи с полным доступом имеют доступ ко всем магазинам
 * @param filter - исходный фильтр
 * @param user - текущий пользователь
 * @param store - текущий магазин пользователя
 * @returns новый фильтр с примененным storeId
 */
export const applyStoreAccessFilter = (filter: TableFilter, user: any, store: any): TableFilter => {
	const newFilter = { ...filter };

	// Администраторы и пользователи с полным доступом имеют доступ ко всем магазинам
	if (!!user && (user?.groups?.includes(GroupsEnum.ADMIN) || user?.groups?.includes(GroupsEnum.FULL_ACCESS))) {
		// Admin and Full Access users have access to all stores
	} else if (store?.id) {
		// Остальные пользователи ограничены своим магазином
		newFilter['storeId'] = store.id;
	}

	return newFilter;
};

/**
 * Определяет storeId для загрузки данных в зависимости от прав доступа
 * @param user - текущий пользователь
 * @param store - текущий магазин пользователя
 * @returns storeId для использования в запросе ('' для доступа ко всем, конкретный id для ограничения, null если доступ запрещен)
 */
export const getStoreIdForDataAccess = (user: any, store: any): string | null => {
	// Администраторы имеют доступ ко всем магазинам
	if (user?.groups?.includes(GroupsEnum.ADMIN)) {
		return '';
	}
	// Пользователи с полным доступом к данным имеют доступ ко всем магазинам
	if (user?.groups?.includes(GroupsEnum.FULL_ACCESS)) {
		return '';
	}
	// РД доступы имеют доступ к своим магазинам (фильтр по РД происходит на бэкенде)
	if (user?.groups?.some((group: string) => group.startsWith('/rdaccess/rdaccess.'))) {
		return '';
	}
	// Остальные пользователи имеют доступ только к своему магазину
	if (store?.id) {
		return store?.id;
	}
	
	return null;
};
